module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00063.c8e5b47.png";